export default {
  layers: {
    exhibition: 'Lieu d\'exposition',
    home: 'Domicile de l\'artiste',
    birth: 'Lieu de naissance de l\'artiste',
    death: 'Lieu de décès de l\'artiste',
    owner: 'Lieu du propriétaire de l\'oeuvre',
    creation: 'Lieu de création de l\'oeuvre'
  },
  message: {
    limit: 'La liste affiche les résultats par page, la carte affiche tous les résultats dans la limite de 3000 éléments.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr_FR/map.js